import React from 'react';
import { Helmet } from 'react-helmet';

var NetworkErrorScreen = function NetworkErrorScreen() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Network Error")), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mt-4"
  }, "Network Error"), /*#__PURE__*/React.createElement("p", null, "Check your internet connection and reload this page."), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    type: "button",
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "Try Again")));
};

export { NetworkErrorScreen };